import React from 'react';
import '../templateBuilder/templateBuilder.css';

interface DashboardOptionsPanelProps {
  onAddQuickWidget: (chartType: string) => void;
}

const DashboardOptionsPanel: React.FC<DashboardOptionsPanelProps> = ({
  onAddQuickWidget,
}) => {
  const chartTypes = [
    { id: 'bar', name: 'Bar Chart', icon: 'fa-chart-bar', color: '#3b82f6', desc: 'Category breakdown chart' },
    { id: 'pie', name: 'Pie Chart', icon: 'fa-chart-pie', color: '#8b5cf6', desc: 'Proportional distribution chart' },
    { id: 'heatmap', name: 'Heatmap / Matrix', icon: 'fa-fire', color: '#ef4444', desc: 'Metric availability matrix' },
    { id: 'line', name: 'Line Chart', icon: 'fa-chart-line', color: '#10b981', desc: 'Trend over time chart' },
    { id: 'card', name: 'Stat Card', icon: 'fa-id-card', color: '#0284c7', desc: 'Single KPI metric summary' },
  ];

  const handleDragStartChartType = (e: React.DragEvent, chartType: string) => {
    e.stopPropagation();
    const payload = { type: 'dashboardChartType', chartType };
    (window as any).__tb_dragged_item = payload;
    if (e.dataTransfer) {
      try {
        const jsonStr = JSON.stringify(payload);
        e.dataTransfer.setData('text/plain', jsonStr);
        e.dataTransfer.setData('application/json', jsonStr);
        e.dataTransfer.effectAllowed = 'copyMove';
      } catch (err) {}
    }
  };

  return (
    <div
      className="card border shadow-sm h-100 d-flex flex-column"
      style={{ backgroundColor: '#fafbfc', borderRadius: '14px' }}
    >
      {/* PANEL HEADER */}
      <div className="card-header bg-white border-bottom p-3 flex-shrink-0">
        <h6 className="fw-bold mb-0 text-dark d-flex align-items-center">
          <i className="fas fa-th-large text-primary me-2"></i>
          Widgets ({chartTypes.length})
        </h6>
      </div>

      {/* PANEL BODY - CHART TYPES LIST */}
      <div className="card-body p-3 overflow-auto" style={{ height: '560px' }}>
        <div className="d-flex flex-column gap-2">
          {chartTypes.map((ct) => (
            <div
              key={ct.id}
              draggable={true}
              onDragStart={(e) => handleDragStartChartType(e, ct.id)}
              className="p-3 border rounded-3 bg-white d-flex align-items-center justify-content-between shadow-xs cursor-grab select-none hover:shadow-sm transition"
              style={{ userSelect: 'none' }}
            >
              <div className="d-flex align-items-center gap-3 pointer-events-none">
                <i className="fas fa-grip-vertical text-black-50 me-1" style={{ fontSize: '11px' }}></i>
                <div
                  className="rounded-3 p-2 d-flex align-items-center justify-content-center text-white"
                  style={{ backgroundColor: ct.color, width: '36px', height: '36px' }}
                >
                  <i className={`fas ${ct.icon}`}></i>
                </div>
                <div>
                  <div className="fw-semibold text-dark small">{ct.name}</div>
                  <div className="text-muted" style={{ fontSize: '11px' }}>
                    {ct.desc}
                  </div>
                </div>
              </div>

              <button
                type="button"
                className="tb-btn tb-btn-primary px-2 py-1 flex-shrink-0"
                style={{ fontSize: '11px' }}
                onClick={() => onAddQuickWidget(ct.id)}
              >
                <i className="fas fa-plus me-1"></i> Add
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* FOOTER HELPER */}
      <div className="card-footer bg-white border-top p-2 text-center text-muted flex-shrink-0" style={{ fontSize: '11px' }}>
        <i className="fas fa-info-circle me-1 text-info"></i>
        Drag widgets or click "+ Add" to insert chart widgets onto canvas rows.
      </div>
    </div>
  );
};

export default DashboardOptionsPanel;
